import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { FaFileAlt } from "react-icons/fa";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { setPageMeta } from "../utils/seo";
import resourcebg1 from "../Assets/resourcebg1.png";
import "./Resources.css";

const fadeUp = {
  hidden: { opacity: 0, y: 45 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: "easeOut" },
  },
};

const Resources = () => {
  useEffect(() => {
    setPageMeta(
      "Resources | Sapiencia.AI",
      "Technical whitepapers, AI security research, and cybersecurity resources from Sapiencia.AI."
    );
  }, []);

  const whitepapers = [
    {
      title:
        "Lightweight Cryptographic Authentication Using Facial Landmarks and LFSR for IoT Security",
      externalLink: "https://ieeexplore.ieee.org/abstract/document/10871851",
    },
    {
      title:
        "A Deep Neural Network-Based Biometric Random Key Generator for Security Enhancement",
      externalLink:
        "https://www.taylorfrancis.com/chapters/edit/10.1201/9781003267812-14/deep-neural-network-based-biometric-random-key-generator-security-enhancement-sannidhan-jason-elroy-martis-sudeepa",
    },
    {
      title:
        "Novel Hybrid Quantum Architecture-Based Lung Cancer Detection Using Chest Radiograph and Computerized Tomography Images",
      externalLink: "https://www.mdpi.com/2306-5354/11/8/799",
    },
    {
      title: "Text-to-Sketch Synthesis via Adversarial Network",
      externalLink: "https://ieeexplore.ieee.org/abstract/document/9214173",
    },
    {
      title:
        "Improving Acne Severity Detection: A GAN Framework with Contour Accentuation for Image Deblurring",
      externalLink:
        "https://openurl.ebsco.com/EPDB%3Agcd%3A13%3A23724461/detailv2?sid=ebsco%3Aplink%3Ascholar&id=ebsco%3Agcd%3A164310655&crl=c&link_origin=scholar.google.com",
    },
    {
      title: "Bioinformatics-Driven Threat Intelligence",
      externalLink:
        "https://www.frontiersin.org/journals/bioinformatics/articles/10.3389/fbinf.2025.1485797/full",
    },
  ];

  return (
    <div className="resources-page">

      <Navbar />

      <section
        className="resources-section resources-whitepapers-section"
        id="whitepapers"
        style={{
          backgroundImage: `
            linear-gradient(
              rgba(5, 10, 20, 0.25),
              rgba(5, 10, 20, 0.25)
            ),
            url(${resourcebg1})
          `,
        }}
      >
        <motion.div
          className="resources-content glass-dark"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.25 }}
        >
          <p className="eyebrow">RESOURCES</p>

          <h2 className="resources-main-title">Technical Whitepapers</h2>

          <p className="subtle">
            Explore research papers, AI security frameworks, and technical
            resources developed across cybersecurity, healthcare AI, and
            intelligent systems.
          </p>

          <div className="whitepaper-grid">
            {whitepapers.map((wp, index) => (
              <a
                key={wp.title}
                className="whitepaper-card glass-lite"
                href={wp.externalLink}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Open ${wp.title}`}
              >

                <div className="whitepaper-card-content">
                  <FaFileAlt className="file-ico" />

                  <span className="whitepaper-title">{wp.title}</span>

                  <span className="download-tag">
                    <FaFileAlt className="download-icon" />
                    Download
                  </span>
                </div>
              </a>
            ))}
          </div>
        </motion.div>
      </section>

      <Footer />
    </div>
  );
};

export default Resources;